import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

GSAP.registerPlugin(ScrollTrigger)

export default class CreditsWindow {
	constructor() {

		this.window 		= document.querySelector('[data-component="creditsWindow"]')
		this.tiles 			= [...document.querySelectorAll('.tile-credit')]
		this.init 			= this.init.bind(this)
		this.destroy 		= this.destroy.bind(this)

		if(this.window){

			this.image			= this.window.querySelector('[data-component="image"]')
			this.title			= this.window.querySelector('[data-component="title"]')
			this.tags			= this.window.querySelector('[data-component="tags"]')
			this.closeBtn		= this.window.querySelector('[data-component="close"]')

			this.init()
			// listen for close
			this.closeBtn.addEventListener('click', (event) => {
				this.window.classList.remove('credits-window--active')
				// reinstate lenis scroll
				window.app.smoothScroll.lenis && window.app.smoothScroll.lenis.start()
			})
		}

	}

	init(){

		if( this.tiles.length > 0 
			&& window.matchMedia('(max-width: 1023px)').matches
			&& window.matchMedia('(hover: none)').matches
		) {

			this.tiles.forEach( (tile, index) => {

				// listen for click
				tile.addEventListener('click', (event) => {
					event.preventDefault()

					let image =	tile.querySelector('[data-component="image"]').cloneNode(true)
					this.image.innerHTML = ''
					this.image.append(image)
					this.title.innerHTML = tile.querySelector('[data-component="title"]').innerHTML
					this.tags.innerHTML = tile.querySelector('[data-component="tags"]').innerHTML
					
					this.window.classList.add('credits-window--active')

					window.app.smoothScroll.lenis && window.app.smoothScroll.lenis.stop()
					
				})

			});
		
		}

		

	}

	destroy() {
		this.tiles.forEach( (tile, index) => {

			// listen for click
			tile.removeEventListener('click', (event) => {})

		});
	}

}
